/**
 * Router state carried into a conference route so leaving it does not depend
 * on what happens to sit behind it in the browser history.
 */
export type ConferenceRouteState = {
  returnTo?: string;
};

/**
 * Read from `window.location`, not the router: chat pages write `?cid=` with
 * raw `history.pushState`, which the router never sees.
 */
export const buildConferenceRouteState = (): ConferenceRouteState => ({
  returnTo: `${window.location.pathname}${window.location.search}`,
});
